import { PrProcessReport } from 'src/app/interfaces/process-reports/pr-process-report';
import { LightUserFactory } from '../core/light-user-factory';
import { LightUser } from 'src/app/interfaces/core/light-user';
import {PrFormValueFactory} from './pr-form-value-factory';
import {PrType} from '../../interfaces/process-reports/pr-type';
import {PrTypeFactory} from './pr-type-factory';
import {PrLabel} from '../../interfaces/process-reports/pr-label';
import {PrLabelFactory} from './pr-label-factory';
import {PrComment} from '../../interfaces/process-reports/pr-comment';
import {PrCommentFactory} from './pr-comment-factory';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {PrFormValue} from '../../interfaces/process-reports/pr-form-value';
import {UserService} from '../../services/core/user.service';
import {DateTime} from 'luxon';

export class PrProcessReportFactory {

  /**
   *
   * @param prProcessReport
   * @returns
   */
  public static fromObject(prProcessReport: any): PrProcessReport {
    return new class implements PrProcessReport {
      text: string = prProcessReport.text;
      userId: number = prProcessReport.user_id;
      serviceFacilityId: number = prProcessReport.service_facility_id;
      user: LightUser = LightUserFactory.fromObject(prProcessReport.user);
      employeeId: number = prProcessReport.employee_id;
      employee: LightEmployee = prProcessReport.employee ? LightEmployeeFactory.fromObject(prProcessReport.employee) : null;
      customerId: number = prProcessReport.customer_id;
      customer: LightCustomer = prProcessReport.customer ? LightCustomerFactory.fromObject(prProcessReport.customer) : null;
      parentId: number = prProcessReport.parent_id;
      prFormValues: any[] = PrFormValueFactory.fromArray(prProcessReport.pr_form_values);
      prTypeId: number = prProcessReport.pr_type_id;
      prType: PrType = PrTypeFactory.fromObject(prProcessReport.pr_type);
      prLabelId: number = prProcessReport.pr_label_id;
      prLabel: PrLabel = prProcessReport.pr_label ? PrLabelFactory.formObject(prProcessReport.pr_label) : null;
      prComments: PrComment[] = prProcessReport.pr_comments ? PrCommentFactory.fromArray(prProcessReport.pr_comments) : null;
      isFlagged: boolean = prProcessReport.is_flagged;
      confirmed: string = prProcessReport.confirmed;
      createdDate: string = prProcessReport.created_date;
      prProcessReports: PrProcessReport[] =
        prProcessReport.pr_process_reports ? PrProcessReportFactory.fromArray(prProcessReport.pr_process_reports) : null;
      confirmedEmployeeId: number = prProcessReport.confirmed_employee_id;
      confirmedEmployee: LightEmployee =
        prProcessReport.confirmed_employee ? LightEmployeeFactory.fromObject(prProcessReport.confirmed_employee) : null;
      // ---------------------------------------------------------------------------------------------------------------
      id: number = prProcessReport.id;
      uuid: string = prProcessReport.uuid;
      modified: string = prProcessReport.modified;
      created: string = prProcessReport.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param prProcessReports
   * @returns
   */
  public static fromArray(prProcessReports: any[]): PrProcessReport[] {
    return prProcessReports.map(_prProcessReport => PrProcessReportFactory.fromObject(_prProcessReport));
  }

  /**
   *
   */
  public static new(prPrecessReport: Partial<PrProcessReport> = {}): PrProcessReport {
    const newPrPrecessReport = new class implements PrProcessReport {
      confirmed: string = null;
      confirmedEmployee: LightEmployee = null;
      confirmedEmployeeId: number = null;
      created: string = null;
      createdDate: string = DateTime.local().toISODate();
      customer: LightCustomer = null;
      customerId: number = null;
      employee: LightEmployee = null;
      employeeId: number = null;
      id: number = null;
      isFlagged: boolean = null;
      modified: string = null;
      parentId: number = null;
      prComments: PrComment[] = null;
      prFormValues: PrFormValue[] = null;
      prLabel: PrLabel = null;
      prLabelId: number = null;
      prProcessReports: PrProcessReport[] = null;
      prType: PrType = null;
      prTypeId: number = null;
      serviceFacilityId: number = null;
      text: string = null;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser());
      userId: number = UserService.getUser().id;
      uuid: string = null;
    };

    return {...newPrPrecessReport, ...prPrecessReport};
  }

  /**
   *
   * @param prProcessReport
   */
  public static toRemote(prProcessReport: PrProcessReport): any {
    return {
      id: prProcessReport.id,
      uuid: prProcessReport.uuid,
      text: prProcessReport.text,
      employee_id: prProcessReport.employeeId,
      customer_id: prProcessReport.customerId,
      pr_form_values: PrFormValueFactory.toArray(prProcessReport.prFormValues),
      pr_type_id: prProcessReport.prTypeId,
      pr_label_id: prProcessReport.prLabelId,
      service_facility_id: prProcessReport.serviceFacilityId,
      created_date: prProcessReport.createdDate,
      modified: prProcessReport.modified,
      created: prProcessReport.created
    };
  }

}
